// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { useEffect, useState, type ReactElement } from 'react';
import { ToastContainer } from '@/components/ToastContainer';
import type { Toast, ToastType } from '@/lib/useToast';

// Uygulama geneli BILDIRIM. Iki ayri tuzagi birden kapatir:
//
// 1) Panel icindeki YEREL toast, eylem bitince panel yenilenip/kapaninca bilesenle beraber yok
//    oluyordu — "6 satirdan 2 eslesti" gibi ozetler kullaniciya HIC ulasmiyordu.
// 2) Mesaji React state'inde tutmak da yetmedi: eylem sonrasi agac yeniden kuruldugunda host
//    remount olup state sifirlaniyor, mesaj yine kayboluyordu (2026-08-05, banka mutabakati
//    "Sistemle eslestir" ile olculdu: olay host'a ULASIYOR ama ekranda gorunmuyordu).
//
// Bu yuzden kuyruk BILESEN DISINDA (modul duzeyinde) yasar; host yalnizca ona abone olur ve
// remount olsa bile mevcut mesajlari yeniden cizer. Kopru window olayidir — dev sunucusunda ayni
// dosya iki modul ornegi olarak yuklenebildigi icin modul degiskenine yazip okumak guvenilmezdi.

const OLAY = 'elpo:toast';

interface ToastDetail {
  readonly type: ToastType;
  readonly message: string;
  readonly duration: number;
}

/**
 * Uygulama genelinde bildirim gösterir.
 *
 * <c>duration = 0</c> verilirse bildirim KENDİLİĞİNDEN KAPANMAZ; kullanıcı "Tamam" diyene kadar
 * durur (kullanıcı kararı 23.09.2026). Kullanıcının okuması gereken yönlendirmeler — "gizlediğin
 * öğeyi şuradan geri açarsın" gibi — birkaç saniyede kaybolursa hiç söylenmemiş sayılır.
 */
export function notify(type: ToastType, message: string, duration = 4000): void {
  if (message.trim() === '') return;
  window.dispatchEvent(new CustomEvent<ToastDetail>(OLAY, { detail: { type, message, duration } }));
}

let kuyruk: readonly Toast[] = [];
let sayac = 0;
const aboneler = new Set<(t: readonly Toast[]) => void>();

function yayinla(): void {
  for (const abone of aboneler) abone(kuyruk);
}

function ekle(d: ToastDetail): void {
  const t: Toast = { id: `g-${++sayac}`, type: d.type, message: d.message, duration: d.duration };
  kuyruk = [...kuyruk, t];
  yayinla();
  if (d.duration > 0) {
    setTimeout(() => { kuyruk = kuyruk.filter((x) => x.id !== t.id); yayinla(); }, d.duration);
  }
}

// Dinleyici modul yuklenirken kurulur; host mount olmadan once gelen mesaj da kuyruga girer.
if (typeof window !== 'undefined') {
  window.addEventListener(OLAY, (e: Event) => {
    const d = (e as CustomEvent<ToastDetail>).detail;
    if (d?.message) ekle(d);
  });
}

export function ToastHost(): ReactElement {
  const [toasts, setToasts] = useState<readonly Toast[]>(kuyruk);

  useEffect(() => {
    aboneler.add(setToasts);
    setToasts(kuyruk);
    return () => { aboneler.delete(setToasts); };
  }, []);

  return (
    <ToastContainer
      toasts={toasts}
      onDismiss={(id) => { kuyruk = kuyruk.filter((x) => x.id !== id); yayinla(); }}
    />
  );
}
